import { UPDATE_CHAT } from "../actions/types";

const initialState = {
  chat: [],
  // user: !localStorage.getItem("user")
  //   ? userIni
  //   : JSON.parse(localStorage.getItem("user")),
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_CHAT:
      let chat = state.chat;

      // if (!chat.hasOwnProperty(action.payload.origin)) {
      //   chat[action.payload.origin] = [];
      // }

      chat.push(action.payload);

      return {
        ...state,
        chat,
      };

    default:
      return state;
  }
}
